export const environment = {
  production: false,
  baseURL: 'https://stage.volga.com.co'
};
